export const getSafeUrl = (url, dummyImg = "") => {
  console.log('url',url);
  
  if (!url) return dummyImg;

  // The base URL of the current environment (e.g. http://localhost:4040)
  const baseUrl = import.meta.env.VITE_APP_BASE_URL || "";

  // 1. If it's a full Azure/external URL, route it through the Secure SAS Proxy
  if (url.startsWith("http")) {
    if (url.includes("/api/media/redirect")) {
      return url; // Already wrapped!
    }
    // ONLY proxy through backend if it's an Azure Storage blob URL
    if (url.includes("blob.core.windows.net")) {
      return `${baseUrl}/api/media/redirect?url=${encodeURIComponent(url)}`;
    }
    // For Airbnb, Dropbox, or other external URLs, return directly so the browser can load them
    return url;
  }

  // 2. Fallback for old local paths
  // Normalize backslashes to forward slashes for URLs
  const cleanUrl = url.replace(/\\/g, "/");

  // Ensure there's exactly one slash between baseUrl and cleanUrl
  const separator = baseUrl.endsWith("/") || cleanUrl.startsWith("/") ? "" : "/";

  return baseUrl + separator + cleanUrl;
};
